import React from 'react';
export const documentSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img"
             width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
            <path fill="#565671"
                  d="M8 1v3.5A1.5 1.5 0 0 0 9.5 6H13v7.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13.5v-11A1.5 1.5 0 0 1 4.5 1H8Zm1 .25V4.5a.5.5 0 0 0 .5.5h3.25L9 1.25Z"/>
        </svg>
    )
}